import { globalToastUIRef } from 'widgets/Toast';

const toast = {
  success: (msg: string) => globalToastUIRef.current?.success(msg),
  error: (msg: string) => globalToastUIRef.current?.error(msg),
  warning: (msg: string) => globalToastUIRef.current?.warning(msg),
};

export default toast;
